import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";

import { BaseResponse, Response } from "../models/api.types";

export function useFileDownload<
  TVariables = any,
  TContext = unknown
>(
  options: UseMutationOptions<AxiosResponse<Blob>, AxiosError<BaseResponse<Response<any>>>, TVariables, TContext>
) {

  const mutation = useMutation(options);

  const download = useCallback(
    async (filename: string, params: TVariables) => {
      try {

        const response = await mutation.mutateAsync(params);
        const objectUrl = URL.createObjectURL(response.data);

        const linkEl = document.createElement('a');
        linkEl.href = objectUrl;
        linkEl.setAttribute('download', filename);
        document.body.appendChild(linkEl);
        linkEl.click();

        document.body.removeChild(linkEl);
        URL.revokeObjectURL(objectUrl);

        return Promise.resolve();

      } catch (error) {
        return Promise.reject(error);
      }
    },
    []
  );

  return {
    ...mutation,
    download
  };
}
